<app-loader></app-loader>
<div class="container-fluid m-0 p-0 h-100">
  <!--Pre-logIn-->
  <div
    class="row m-0"
    [ngClass]="{
      layout: !isIdentityVerificationHandoff && !isPublicShellPage,
      'public-auth-layout': !isIdentityVerificationHandoff && isPublicShellPage,
      'identity-verification-layout': isIdentityVerificationHandoff
    }"
  >
    <app-landing-page-header
      class="public-auth-header"
      *ngIf="!isIdentityVerificationHandoff && isPublicShellPage"
    ></app-landing-page-header>

    <!-- If not auth module -->
    <app-header
      class="layout-header"
      *ngIf="
        !isIdentityVerificationHandoff && !isPublicShellPage && !isLandingPage
      "
    ></app-header>

    <!-- Content -->
    <section
      [ngClass]="{
        'public-page-content':
          !isIdentityVerificationHandoff && isPublicShellPage,
        'public-discovery-content':
          !isIdentityVerificationHandoff &&
          isPublicShellPage &&
          isPublicContentPage,
        'public-auth-content':
          !isIdentityVerificationHandoff && isPublicAuthPage,
        'layout-content': !isIdentityVerificationHandoff && !isPublicShellPage,
        'identity-verification-content': isIdentityVerificationHandoff
      }"
    >
      <div
        [ngClass]="{
          'site-content-container public-auth-route': isPublicAuthPage,
          'public-page-route':
            isPublicShellPage && !isPublicAuthPage && !isLandingPage
        }"
      >
        <router-outlet></router-outlet>
      </div>
    </section>

    <app-landing-page-footer
      class="public-auth-footer"
      *ngIf="!isIdentityVerificationHandoff && isPublicShellPage"
    ></app-landing-page-footer>

    <app-landing-page-footer
      class="layout-footer"
      *ngIf="
        !isIdentityVerificationHandoff && !isPublicShellPage && !isLandingPage
      "
    ></app-landing-page-footer>
  </div>

  <app-help-bot
    class="app-help-bot"
    *ngIf="getUserLoggedIn() && !isIdentityVerificationHandoff"
  ></app-help-bot>
</div>
